// extracted by mini-css-extract-plugin
export var carrierIconPlaceholder = "_7a-1";
export var dragButton = "_7a-5";
export var sortableCell = "_7a-4";
export var sortableNameCell = "_7a-3";
export var sortableRow = "_7a-0";
export var tableHeader = "_7a-6";
export var tableHeaderWithCardHeader = "_7a-7";
export var weightInputRow = "_7a-2";